import { ticketProps } from "@shared/components/tickets/constants";

export const clientId = "smx-asset-mgmt";
export const assetManagementTicketType = "asset.ticket.produktion";
export const prefix = "asset.produktion.";

export const roles = {
  admin: "admin",
  user: "user",
  planner: "planner",
  ticketCreator: "ticket-creator",
};

export const assetManagementTicketProps = {
  ...ticketProps,
  asset: "asset",
  area: "area",
  responsibility: "responsibility",
};
